export default {
    state: {
        smsGateways: [],
        smsGatewayTypes: [],
        smsGatewayTypesLoaded: false,
    },
    actions: {
        fetchSmsGatewayTypes({state, commit, getters}) {
            return new Promise((resolve, reject) => {
                if (state.smsGatewayTypesLoaded) return resolve(state.smsGatewayTypes)
                if (!getters.getApiToken) return reject(false)

                this.$api.userSmsGateway.getTypes()
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('setSmsGatewayTypes', response.data || [])
                            resolve(response.data)
                        } else {
                            console.error(response);
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        fetchUserSmsGateways({commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args?.userId) {
                    return reject(false)
                }
                this.$api.userSmsGateway.findAll(args.userId)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('setUserSmsGatewaysByUserId', {userId: args.userId, items: response.data || []})
                            resolve(response)
                        } else {
                            console.error(response);
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            });
        },
        saveUserSmsGateway({commit}, {userId, id, ...data}) {
            return new Promise((resolve, reject) => {
                const request = id
                    ? this.$api.userSmsGateway.update(userId, id, data)
                    : this.$api.userSmsGateway.create(userId, data)
                request
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateUserSmsGateway', {userId, data: response.data})
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        deleteUserSmsGateway({commit}, {userId, id}) {
            return new Promise((resolve, reject) => {
                this.$api.userSmsGateway.delete(userId, id)
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data?.error)) {
                            commit('deleteUserSmsGateway', id)
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
    },
    mutations: {
        setSmsGatewayTypes(state, types) {
            state.smsGatewayTypes = types
            state.smsGatewayTypesLoaded = true
        },
        setUserSmsGatewaysByUserId(state, {userId, items}) {
            const others = state.smsGateways.filter(g => g.creator != userId)
            state.smsGateways = [...others, ...items.map(g => Object.freeze(g))]
        },
        updateUserSmsGateway(state, {userId, data}) {
            if (!data?.id) return
            let i = state.smsGateways.findIndex(g => g.id == data.id)
            if (i < 0) {
                state.smsGateways.push(Object.freeze({...data, creator: userId}))
            } else {
                state.smsGateways[i] = Object.freeze({...state.smsGateways[i], ...data})
            }
        },
        deleteUserSmsGateway(state, id) {
            state.smsGateways = state.smsGateways.filter(g => g.id != id)
        },
        clearUserSmsGateways(state) {
            state.smsGateways = []
        },
    },
    getters: {
        getSmsGatewayTypes(state) {
            return state.smsGatewayTypes
        },
        getSmsGatewayTypesByIds(state) {
            return state.smsGatewayTypes
                .reduce((byIds, type) => {
                    byIds[type.id] = type
                    return byIds
                }, {})
        },
        getUserSmsGateways(state) {
            return state.smsGateways
        },
        getUserSmsGatewaysByIds(state) {
            return state.smsGateways
                .reduce((byIds, gateway) => {
                    byIds[gateway.id] = gateway
                    return byIds
                }, {})
        },
        getUserSmsGatewaysByUserId(state) {
            return state.smsGateways
                .reduce((byUserId, gateway) => {
                    if (!byUserId[gateway.creator]) byUserId[gateway.creator] = []
                    byUserId[gateway.creator].push(gateway)
                    return byUserId
                }, {})
        },
    },
}
